import type {
  InventoryImportStatus,
  InventoryReportType,
} from 'contracts/inventory-2/uploads';
import { INVENTORY_UPLOAD_TYPE_OPTIONS } from 'constants/inventory-2/uploads';

export const getTypeName = (type: InventoryReportType) => {
  return INVENTORY_UPLOAD_TYPE_OPTIONS.find((option) => option.value === type)?.name || type;
};

export const getStatusName = (status: InventoryImportStatus) => {
  switch (status) {
    case 'finished':
      return 'Concluído';
    case 'failed':
      return 'Falhou';
  }
};

export const toSourceFileHref = (fileUrl: string) => {
  if (fileUrl.startsWith('http://') || fileUrl.startsWith('https://')) {
    return fileUrl;
  }

  return `https://${fileUrl}`;
};
